import {Component, OnInit} from '@angular/core';
import {Destroyable} from './components/destroyable';
import {takeUntil} from 'rxjs/operators';
import {Campaign, CampaignsService} from 'gamesis-story-client';
import * as FileSaver from 'file-saver';
import {ActionSheetController, NavController, Platform} from '@ionic/angular';
import {FilePicker} from '@capawesome/capacitor-file-picker';
import {Router} from '@angular/router';
import {
    deleteCampaign,
    exitCampaign,
    initialize,
    selectCharacterCount,
    selectCount,
    selectCurrentCampaign,
    selectPlayerCount
} from 'gamesis-state';
import {Store} from '@ngrx/store';
import {Observable} from 'rxjs';


@Component({
    template: `
        <ion-app>
            <ion-split-pane contentId="main">
                <ion-menu contentId="main" type="overlay" side="start">
                    <ion-content color="dark" scrollY="false">
                        <ion-list lines="full" logo class="bg-dark">
                            <ion-item color="transparent" class="ion-align-items-end">
                                <ion-label color="black" class="shout">
                                    {{ campaign?.name }}
                                </ion-label>
                                <ng-container *gm>
                                    <ion-icon name="cog"
                                              slot="end"
                                              color="black"
                                              (click)="settings()"></ion-icon>
                                </ng-container>
                            </ion-item>
                            <ion-menu-toggle autoHide="false">
                                <ion-item color="transparent" routerDirection="root" routerLink="/story" detail="false">
                                    <ion-label>Story</ion-label>
                                    <ion-label slot="end" class="monospaced">{{ events$ | async }}</ion-label>
                                </ion-item>
                                <ion-item color="transparent" routerDirection="root" routerLink="/characters" detail="false">
                                    <ion-label>Characters</ion-label>
                                    <ion-label slot="end" class="monospaced">{{ characters$ | async }}</ion-label>
                                </ion-item>
                                <ion-item color="transparent" routerDirection="root" routerLink="/players" detail="false">
                                    <ion-label>Players</ion-label>
                                    <ion-label slot="end" class="monospaced">{{ players$ | async }}</ion-label>
                                </ion-item>
                                <ion-item color="transparent" routerDirection="root" routerLink="/story/help" detail="false">
                                    <ion-label>Help</ion-label>
                                </ion-item>
                                <ion-item button color="transparent" (click)="exit()" detail="false">
                                    <ion-label>Exit</ion-label>
                                </ion-item>
                            </ion-menu-toggle>
                        </ion-list>
                    </ion-content>
                    <ion-footer>
                        <ion-item color="dark">
                            <ion-label color="light" class="ion-text-center">
                                <small>
                                    <info class="monospaced"></info>
                                </small>
                            </ion-label>
                        </ion-item>
                    </ion-footer>
                    <menu-toggle [reversed]="true"></menu-toggle>
                </ion-menu>
                <ion-router-outlet id="main"></ion-router-outlet>
                <menu-toggle></menu-toggle>
            </ion-split-pane>
        </ion-app>
    `,
    styles: [`
        ion-menu::part(backdrop) {
            /*background: rgba(90, 255, 0, 0.99) !important;*/
        }

        ion-menu.show-menu::part(container) {
            box-shadow: 0 0 100px var(--ion-color-black);
        }
    `],
    standalone: false
})
export class Menu extends Destroyable implements OnInit {
    public campaign: Campaign;
    public events$: Observable<number>;
    public characters$: Observable<number>;
    public players$: Observable<number>;

    constructor(private navCtrl: NavController,
                public platform: Platform,
                private actionSheetCtrl: ActionSheetController,
                private store: Store,
                private campaignsService: CampaignsService) {
        super();
    }

    ngOnInit(): void {
        this.store.select(selectCurrentCampaign)
            .pipe(takeUntil(this.ngUnsubscribe))
            .subscribe(campaign => {
                if (!campaign) {
                    this.navCtrl.navigateRoot(['/']);
                }
                this.campaign = campaign;
            });

        this.events$ = this.store.select(selectCount);
        this.characters$ = this.store.select(selectCharacterCount);
        this.players$ = this.store.select(selectPlayerCount);
    }

    exit() {
        this.store.dispatch(exitCampaign());
    }

    settings(): void {
        const buttons = [];

        if (!this.platform.is('capacitor')) {
            buttons.push({
                text: 'Backup',
                handler: () => {
                    this.campaignsService.readCampaign(this.campaign.id)
                        .subscribe(campaign => {
                            const blob = new Blob([JSON.stringify(campaign)], {type: 'text/json'});
                            FileSaver.saveAs(blob, this.campaign.name + '.json');
                        });
                }
            }, {
                text: 'Restore',
                handler: () => {
                    FilePicker.pickFiles({
                        types: ['text/json'],
                        limit: 1,
                        readData: true
                    }).then(result => {
                        result.files[0].blob.text().then(json => {
                            this.campaignsService.restore(this.campaign.id, JSON.parse(json))
                                .subscribe(campaign => {
                                    // restored
                                    this.store.dispatch(initialize());
                                });
                        });
                    });
                }
            });
        }

        buttons.push({
            text: 'Delete',
            role: 'destructive',
            handler: () => {
                this.actionSheetCtrl.create({
                    header: 'Please Confirm',
                    subHeader: 'Are you sure you want to delete?',
                    buttons: [{
                        text: 'Delete',
                        role: 'destructive',
                        handler: () => {
                            this.store.dispatch(deleteCampaign());
                        }
                    }, {
                        text: 'Cancel',
                        role: 'cancel'
                    }]
                }).then(actionSheet => actionSheet.present());
            }
        }, {
            text: 'Cancel',
            role: 'cancel'
        });


        this.actionSheetCtrl.create({
            header: 'Settings',
            buttons: buttons,
            cssClass: 'monospaced',
        }).then(actionSheet => actionSheet.present());
    }
}
